document.addEventListener('DOMContentLoaded', function() {
  initflickityShopIndividual();
  initflickityRecommendation();
  initflickityRecommendationJSC();
  initflickityHalfBannercollection();
  updateWidgetPosition();
  pdpReduceBottomPadding();
  onloadReadmore();
  showCta();
  updatePaginationNav();
  setLinkTextDecoration();
  updateMobileSalesPointSpacing();
  adjustHeader();
  adjustFilterText();
  openLinkNewTab();
  addToCartProductComponent();
});

// global variable
var scrollPos;

showDescTab = (e) => {
  var parentAccordion = $(e).parent();
  parentAccordion.toggleClass('is-active');

  if (parentAccordion.hasClass('is-active')) {
    $(parentAccordion).find('.jsc-tab-content').show();
    $(e).find('.jsc-chevron-up').show();
    $(e).find('.jsc-chevron-down').hide();
  } else {
    $(parentAccordion).find('.jsc-tab-content').hide();
    $(e).find('.jsc-chevron-up').hide();
    $(e).find('.jsc-chevron-down').show();
  }
};

jscVarSelected = (element, currentPrice, currentComparePrice, imageSrc) => {
  var $this = $(element);
  const variantDataString = element.getAttribute('data-variant');
  const variantData = JSON.parse(variantDataString);

  const $parentThis = $this
    .parents('.jsc-grid-variants')
    .siblings('.jsc-data-var-atb');

  const $atbButton = $this
    .parents('.jsc-grid-variants')
    .siblings('.jsc-grid-atb-style');

  const priceElement = $atbButton.find('.jsc-grid-price');

  $parentThis.attr('data-var-title', variantData.title);
  $parentThis.attr('data-var-id', variantData.id);
  $parentThis.attr('data-var-avail', variantData.available);
  $this
    .parents('.grid-product__content')
    .find('.grid-product__image')
    .attr('srcset', imageSrc);
  /* Boost added */
  $this.parents('.boost-sd__product-item').find('.grid-product__image').attr('srcset', imageSrc);


  $this.siblings().removeClass('jsc-selected');
  $this.addClass('jsc-selected');

  priceElement.html(currentPrice);

  // Compare price logic
  if (variantData.compare_at_price > variantData.price) {
    $atbButton
      .find('.jsc-grid-discount-compare-price')
      .html(currentComparePrice);
    priceElement.addClass('jsc-grid-discount-price');
  } else {
    $atbButton.find('.jsc-grid-discount-compare-price').html('');
    priceElement.removeClass('jsc-grid-discount-price');
  }

  // Not available logic
  if (!variantData.available) {
    $atbButton.addClass('BIS_trigger jsc-grid-notifyme');
    $atbButton.removeAttr('onclick', 'addToCartProduct(this)');
    $atbButton.find('.jsc-grid-btn-title').html('Notify Me');
    $atbButton
      .find('.jsc-grid-btn-title')
      .addClass('BIS_trigger jsc-grid-notifyme');
  } else {
    $atbButton.removeClass('BIS_trigger jsc-grid-notifyme');
    $atbButton.attr('onclick', 'addToCartProduct(this)');
    $atbButton.find('.jsc-grid-btn-title').html('Add to bag');
    $atbButton
      .find('.jsc-grid-btn-title')
      .removeClass('BIS_trigger jsc-grid-notifyme');
  }
};

initflickityShopIndividual = () => {
  let timer = setInterval(function () {
    if ($(window).width() > 1025) {
      if ($('.jsc-shop-individual-flickity').length > 0) {
        let countGrid = $(
          '.jsc-shop-individual-flickity .jsc-grid__item'
        ).length;
        if (countGrid > 4) {
          var flkty = new Flickity('.jsc-shop-individual-flickity', {
            cellAlign: 'center',
            contain: false,
            pageDots: false,
            groupCells: true,
            wrapAround: true,
            draggable: true,
            prevNextButtons: false,
            on: {
              ready: function () {
                $(this.element).addClass('jsc-flickity-initiated');
              },
            },
          });
        } else {
          $('.jsc-shop-individual-flickity').addClass(
            'jsc-shop-individual-flex'
          );
        }
      }
      clearInterval(timer);
    } else if ($(window).width() > 799 && $(window).width() < 1024) {
      if ($('.jsc-shop-individual-flickity').length > 0) {
        let countGrid = $(
          '.jsc-shop-individual-flickity .jsc-grid__item'
        ).length;
        if (countGrid > 3) {
          var flkty = new Flickity('.jsc-shop-individual-flickity', {
            cellAlign: 'center',
            contain: true,
            pageDots: false,
            groupCells: true,
            wrapAround: false,
            draggable: true,
            prevNextButtons: false,
            on: {
              ready: function () {
                $(this.element).addClass('jsc-flickity-initiated');
              },
            },
          });
        } else {
          $('.jsc-shop-individual-flickity').addClass(
            'jsc-shop-individual-flex'
          );
        }
      }
      clearInterval(timer);
    }
  }, 800);
};

initflickityRecommendation = () => {
  let timer = setInterval(function () {
    if ($(window).width() > 799 && $(window).width() < 1024) {
      if ($('.jsc-recommendation-flickity').length > 0) {
        let countGrid = $(
          '.jsc-recommendation-flickity .jsc-grid__item'
        ).length;
        if (countGrid > 3) {
          if ($('.jsc-feat-col-flex').length > 0) {
            $('.jsc-recommendation-flickity').removeClass('jsc-feat-col-flex');
          }
          var flkty = new Flickity('.jsc-recommendation-flickity', {
            cellAlign: 'center',
            contain: true,
            pageDots: false,
            groupCells: true,
            wrapAround: false,
            draggable: true,
            prevNextButtons: false,
            on: {
              ready: function () {
                $(this.element).addClass('jsc-flickity-initiated');
              },
            },
          });
        } else {
          $('.jsc-recommendation-flickity').addClass(
            'jsc-shop-individual-flex'
          );
        }
      }
      // clearInterval(timer) can be uncommented if one-time init is desired
    }
  }, 800);
};

initflickityRecommendationJSC = () => {
  let timer = setInterval(function () {
    if ($(window).width() > 1025) {
      if ($('.jsc-pdp-recommend-flickity').length > 0) {
        let countGrid = $('.jsc-pdp-recommend-flickity .jsc-grid__item').length;
        if (countGrid > 4) {
          var flkty = new Flickity('.jsc-pdp-recommend-flickity', {
            cellAlign: 'center',
            contain: false,
            pageDots: false,
            groupCells: true,
            wrapAround: true,
            draggable: true,
            prevNextButtons: false,
            on: {
              ready: function () {
                $(this.element).addClass('jsc-flickity-initiated');
              },
            },
          });
        } else {
          $('.jsc-pdp-recommend-flickity').addClass('jsc-shop-individual-flex');
        }
      }
      clearInterval(timer);
    } else if ($(window).width() > 799 && $(window).width() < 1024) {
      if ($('.jsc-pdp-recommend-flickity').length > 0) {
        let countGrid = $('.jsc-pdp-recommend-flickity .jsc-grid__item').length;
        if (countGrid > 3) {
          var flkty = new Flickity('.jsc-pdp-recommend-flickity', {
            cellAlign: 'center',
            contain: true,
            pageDots: false,
            groupCells: true,
            wrapAround: false,
            draggable: true,
            prevNextButtons: false,
            on: {
              ready: function () {
                $(this.element).addClass('jsc-flickity-initiated');
              },
            },
          });
        } else {
          $('.jsc-pdp-recommend-flickity').addClass('jsc-shop-individual-flex');
        }
      }
      clearInterval(timer);
    }
  }, 800);
};

initflickityHalfBannercollection = () => {  
  var galleryElems = document.querySelectorAll('.jsc-half-bannerColl-flickity');
  var countGrid = 0;
  var timer = setInterval(function () {
    if ($(window).width() > 1025) {
    }
    if ($('.jsc-half-bannerColl-flickity').length > 0) {
      $('.jsc-half-bannerColl-flickity .jsc-grid__item').each(function () {
        countGrid += 1;
      });
      if (countGrid > 2) {
        for (var i = 0, len = galleryElems.length; i < len; i++) {
          var galleryElem = galleryElems[i];

          new Flickity(galleryElem, {
            cellAlign: 'center',
            contain: false,
            pageDots: false,
            groupCells: true,
            wrapAround: true,
            draggable: true,
            prevNextButtons: true,
            autoPlay: false,
            setGallerySize: true,
            on: {
              ready: function () {
                $(this.element).addClass('jsc-flickity-initiated');
              },
            },
          });
        }
      }

      setTimeout(() => {
        if ($(window).width() > 1024) {
          var bannerImageDiv = $(
            '.jsc-banner-collection .jsc-banner-div-desktop'
          );
          $(bannerImageDiv).each(function (index, image) {
            var video = $(image).find('video');
            var img = $(image).find('img');
            var height;

            if (video.length > 0) {
              height = $(video).height();
            } else {
              height = $(img).height();
            }

            var sliderGrid = $(image)
              .parents('.jsc-banner-link')
              .siblings('.jsc-new-feat-coll')
              .find('.jsc-half-bannerColl-flickity .jsc-grid__item');
            var sliderViewport = $(image)
              .parents('.jsc-banner-link')
              .siblings('.jsc-new-feat-coll')
              .find('.flickity-viewport');
            sliderGrid.css('height', height);
            sliderViewport.css('height', height);
          });
        } else {
          $('.jsc-half-bannerColl-flickity .jsc-grid__item').css(
            'height',
            '100%'
          );
        }
        // Use the function to apply each style
        applyStyleToClass('jsc-new-feat-coll', 'opacity', 1);
        applyStyleToClass('half-grid-loading-container', 'opacity', 0);
        applyStyleToClass('jsc-banner-collection', 'height', 'auto');
      }, 1500);
    }

    clearInterval(timer);
  }, 800);
};

applyStyleToClass = (className, styleProperty, value) => {
  Array.from(document.getElementsByClassName(className)).forEach(element => {
    element.style[styleProperty] = value;
  });
}

showAccountdropdown = () => {
  $('.jsc-account-dropdown-div').show();
};

hideAccountdropdown = () => {
  $('.jsc-account-dropdown-div').hide();
};

updateWidgetPosition = () => {
  var timer = setInterval(function () {
    if ($('#smile-ui-container').length > 0) {
      $('#smile-ui-container').attr('style', [
        'z-index: 28 !important;position:fixed',
      ]);
      clearInterval(timer);
    }
  }, 500);

  setTimeout(function () {
    if ($('.eGvvXF').length > 0) {
      $('.eGvvXF').attr('style', ['z-index: 0 !important;position:fixed']);
    }
  }, 2000);
};

jscUpdatePrice = (varTitle) => {
  $('.jsc-mobile-product-price').each(function () {
    var $this = $(this);
    var $thisPrice = $this.attr('data-price');
    var $thisTitle = $this.attr('data-title');
    var $thisComparePrice = $this.attr('data-compare-price');
    var $thisSaveAmount = $this.attr('data-saved');

    if ($thisTitle == varTitle) {
      //console.log($thisPrice);
      $('.jsc-variantAndPriceTablet .product__price').html($thisPrice);
      $(
        '.jsc-variantAndPriceTablet .product__price.product__price--compare'
      ).html($thisComparePrice);
      $('.jsc-variantAndPriceTablet .product__price-savings')
        .find('span')
        .html($thisSaveAmount);

      //price on top of mobile image
      $('.jsc-pdp-tablet-down .product__price').find('span').html($thisPrice);
      $('.jsc-pdp-tablet-down .product__price.product__price--compare').html(
        $thisComparePrice
      );

      //price under product title for desktop
      $('.jsc-priceAndRatings .product__price.product__price--compare').html(
        $thisComparePrice
      );

      if (
        $thisComparePrice != '' ||
        $thisComparePrice != undefined ||
        $thisComparePrice != 0
      ) {
        $(
          '.jsc-pdp-tablet-down .product__price:not(.product__price--compare)'
        ).addClass('on-sale');
        $('.jsc-variantAndPriceTablet .product__price-savings')
          .siblings('.product__price:not(.product__price--compare)')
          .addClass('on-sale');
      } else {
        $('.jsc-discount-badge').hide();
        $(
          '.jsc-pdp-tablet-down .product__price:not(.product__price--compare)'
        ).removeClass('on-sale');
        $('.jsc-variantAndPriceTablet .product__price-savings')
          .siblings('.product__price:not(.product__price--compare)')
          .removeClass('on-sale');
      }
    }
  });
};

pdpReduceBottomPadding = () => {
  if ($('.jsc-reduce-bp').length > 0) {
    $('.jsc-reduce-bp').parent().addClass('jsc-reduce-bp-parent');
  }
};

togglePlusMinusIcon = (e) => {
  setTimeout(function () {
    if ($(e).hasClass('is-open')) {
      $(e).find('.jsc-minus').show();
      $(e).find('.jsc-plus').hide();
    } else {
      $(e).find('.jsc-minus').hide();
      $(e).find('.jsc-plus').show();
    }
  }, 200);
};

onloadReadmore = () => {
  //length in characters
  var maxLength = 300;
  var ellipsestext = '...';
  var moretext = 'Read more';
  var lesstext = 'Read less';
  $('.show-read-more').each(function () {
    //get the text of paragraph or div
    var myStr = $(this).text();

    // check if it exceeds the maxLength limit
    if ($.trim(myStr).length > maxLength) {
      //get only limited string firts to show text on page load
      var newStr = myStr.substring(0, maxLength);

      //get remaining string
      var removedStr = myStr.substr(maxLength);
      // original code but it cuts of some of the text     var removedStr = myStr.substr(maxLength, $.trim(myStr).length - maxLength);
      // now append the newStr + "..."+ hidden remaining string
      var Newhtml =
        newStr +
        '<span class="moreellipses">' +
        ellipsestext +
        '</span><span class="morecontent"><span>' +
        removedStr +
        '</span>&nbsp;&nbsp;<a href="javascript:void(0)" class="ReadMore">' +
        moretext +
        '</a></span>';
      //
      $(this).html(Newhtml);
    }
  });

  //function to show/hide remaining text on ReadMore button click
  $('.ReadMore').click(function () {
    if ($(this).hasClass('less')) {
      $(this).removeClass('less');
      $(this).html(moretext);
    } else {
      $(this).addClass('less');
      $(this).html(lesstext);
    }

    $(this).parent().prev().toggle();
    $(this).prev().toggle();
    return false;
  });
};

discountBadge = () => {
  setTimeout(function () {
    var $varId = $('.jsc-variant-list').find(':selected').val();
    var $varDisPerc = $('.jsc-variant-list')
      .find(':selected')
      .attr('data-discount-percent-off');
    var $varDisPrice = $('.jsc-variant-list')
      .find(':selected')
      .attr('data-discount-price-off');

    if (
      $varDisPerc != undefined ||
      $varDisPrice != undefined ||
      varDisPerc != 0
    ) {
      $('.jsc-discount-off').text($varDisPerc + '% OFF');
      $('.jsc-price-off').text($varDisPrice + ' OFF');

      $('.jsc-discount-badge').show();
      $('[data-compare-price]').show();
    } else {
      // empty text if no discount
      $('.jsc-discount-off').text('');
      $('.jsc-price-off').text('');

      // hide badge and compare price if no discount
      $('.jsc-discount-badge').hide();
      $('[data-compare-price]').hide();
    }
  }, 10);
};

$(window).on('scroll', function () {
  scrollPos = $(window).scrollTop();
});

updateBanner = (element) => {
  // update banner price and variant ID
  setTimeout(function () {
    var currentPrice = $('.jsc-variant-list option:selected').data('price');
    var comparePrice = $('.jsc-variant-list option:selected').data(
      'compare-price'
    );
    var $actualPrice = $(
      '.jsc-atc-banner .jsc-atc-banner-right .jsc-atc-banner-price .jsc-atc-banner-actual-price'
    );
    var $comparePrice = $(
      '.jsc-atc-banner .jsc-atc-banner-right .jsc-atc-banner-price .jsc-atc-banner-compare-price'
    );

    $actualPrice.text(currentPrice);
    if (comparePrice != '') {
      var currentPriceNum = parseFloat(currentPrice.replace(/[^\d.-]/g, ''));
      var comparePriceNum = parseFloat(comparePrice.replace(/[^\d.-]/g, ''));

      if (currentPriceNum < comparePriceNum) {
        // on discount
        $actualPrice.css('color', 'red');
        $comparePrice.removeClass('d-none');
        $comparePrice.text(comparePrice);
      } else {
        // no discount
        $actualPrice.css('color', 'black');
        $comparePrice.addClass('d-none');
      }
    } else {
      // no compare price
      $actualPrice.css('color', 'black');
      $comparePrice.addClass('d-none');
    }

    var varId = $('.jsc-variant-list').val();
    $('.jsc-atc-banner .jsc-atc-banner-right')
      .find("[name='id']")
      .val(parseInt(varId));
  }, 10);

  // update banner variant image
  var currentVariantImage = $(element).data('img-url');
  var bannerImg = $('.jsc-atc-banner-left img');
  bannerImg.attr('src', currentVariantImage);

  // toggle button based on variant
  var isAvailable = $(element).data('available');

  $('.jsc-atc-banner').focus();

  var atbBtn = $('.jsc-atc-banner .jsc-atc-banner-right .jsc-atc-banner-bag');
  var notifyBtn = $(
    '.jsc-atc-banner .jsc-atc-banner-right .jsc-atc-banner-notify'
  );

  if (isAvailable == true) {
    atbBtn.css('display', 'block');
    notifyBtn.css('display', 'none');
  } else {
    atbBtn.css('display', 'none');
    notifyBtn.css('display', 'block');
  }

  // prevent scrolling top
  window.scrollTo({
    top: scrollPos,
  });
};

ctaBannerWidgetPositionDesktop = (bannerHeight) => {
  const desktopHeight = 122;

  var timer = setInterval(function () {
    if(bannerHeight > desktopHeight) {
      $('#reamaze-widget').addClass('move--top-desktop');
      $('#smile-ui-lite-container').addClass('move--top-desktop');
      $('.okeLoyalty .c-app--bottomRightAligned').addClass('move--top-desktop');
    } else {
      $('#reamaze-widget').removeClass('move--top-desktop');
      $('#smile-ui-lite-container').removeClass('move--top-desktop');
      $('.okeLoyalty .c-app--bottomRightAligned').removeClass('move--top-desktop');
    }
    clearInterval(timer);
  }, 100);
};

ctaBannerWidgetPositionMobile = (bannerHeight) => {
  const mobileHeight = 98;

  var timer = setInterval(function () {
    if(bannerHeight > mobileHeight) {
      $('#reamaze-widget').addClass('move--top-mobile');
      $('#smile-ui-lite-launcher-frame-container').addClass('move--top-mobile');
      $('.okeLoyalty .c-app--bottomRightAligned').addClass('move--top-mobile');
    } else {
      $('#reamaze-widget').removeClass('move--top-mobile');
      $('#smile-ui-lite-launcher-frame-container').removeClass('move--top-mobile');
      $('.okeLoyalty .c-app--bottomRightAligned').removeClass('move--top-mobile');
    }

    clearInterval(timer);
  }, 100);
};

showCta = () => {
  var element = $('.jsc-pdp-page-content .jsc-pdp-page-width');
  if (element.length > 0) {
    $(window).scroll(function () {
      if ($(window).width() < 481) {
        if ($(window).scrollTop() >= 950) {
          $('.jsc-atc-banner').css('display', 'flex');
          var bannerHeight = $('.jsc-atc-banner').outerHeight(true) + 12;
          ctaBannerWidgetPositionMobile(bannerHeight);
        } else {
          $('.jsc-atc-banner').css('display', 'none');
          ctaBannerWidgetPositionMobile(25);
        }
      } else {
        if ($(window).scrollTop() >= 650) {
          $('.jsc-atc-banner').css('display', 'flex');
          var bannerHeight = $('.jsc-atc-banner').outerHeight(true) + 12;
          ctaBannerWidgetPositionDesktop(bannerHeight);
        } else {
          $('.jsc-atc-banner').css('display', 'none');
          ctaBannerWidgetPositionDesktop(20);
        }
      }
    });
  }
};

clickAddToCart = () => {
  // Reference to the clicked banner button 
  const triggerBtn = $('.jsc-atc-banner-bag');
  const atcButton = $(
    '.template-product .jsc-pdp-blocks .product-single__form'
  ).find("[name='add']");
  atcButton.click();

  // Add loading class to the banner button 
  triggerBtn.addClass('btn--loading');

  // Remove the loading class after 2.5 seconds
  setTimeout(() => {
    triggerBtn.removeClass('btn--loading');
  }, 2500);
};

toggleSelector = (selector) => {
  $(selector).toggleClass('is-active');
};

selectOption = (option) => {
  $(option).siblings().removeClass('is-selected');
  $(option).addClass('is-selected');
  var selectedOption = $(option).text();
  var parent = $(option).parent().parent();
  var headerText = $(parent).find('.jsc-selector-header');
  headerText.text(selectedOption);
  var selectedOptionValue = $(option).data('value');
  $(option).parent().attr('data-selected-value', selectedOptionValue);
};

submitProductFilter = (button) => {
  var parentSibling = $(button).parent().siblings('.jsc-filter-form');
  var option1 = parentSibling.find('#jsc-filter-skin-option').attr('data-selected-value') || "/collections/all";
  var option2 = parentSibling.find('#jsc-filter-concern-option').attr('data-selected-value');
  option2 = option2.replace(/ /g, '+');
  var errorBox =  $(button).siblings('.error_filter');
  if(!option1 || !option2){errorBox.text('Please select your skin type & product type to proceed.').show(); return;} 
  var filterBy = $(button).data('filter-by');
  var newUrl =
    option1 +
    '?' +
    filterBy +
    '=' +
    option2;
  window.location.href = newUrl;
};

updatePaginationNav = () => {
  setInterval(function () {
    var paginationNav = $(
      '.grid .boost-pfs-filter-bottom-pagination.pagination'
    );
    if (paginationNav.length > 0) {
      if (paginationNav.children().length > 0) {
        if ($(window).width() < 799) {
          paginationNav.css('padding', '45px 0 60px 0');
        } else {
          paginationNav.css('padding', '30px 0 60px 0');
        }
      } else {
        paginationNav.css('padding', '0');
      }
    }
  }, 1000);
};

setLinkTextDecoration = () => {
  var cpDescription = $('.jsc-collection-description');
  if (cpDescription.length > 0) {
    cpDescription
      .find('a')
      .attr('style', [
        'text-decoration: underline !important; text-decoration-color: #008391 !important; color: #008391 !important;',
      ]);
  }
};

updateMobileSalesPointSpacing = () => {
  if ($(window).width() < 481) {
    var textBanner = $(
      '.template-product .product-block.jsc-product-block-text'
    );
    if (textBanner.length > 0) {
      $('.product-block--sales-point.product-block').css(
        'margin-bottom',
        '20px'
      );
    } else {
      $('.product-block--sales-point.product-block').css(
        'margin-bottom',
        '25px'
      );
    }
  }
};

adjustHeader = () => {
  var announcementBarHeight = $(
    '.jsc-main-header .announcement-bar'
  ).outerHeight(true);
  var headerHeight = $(
    '.jsc-main-header .jsc-site-header.site-header'
  ).outerHeight(true);
  var header = $('.jsc-main-header .jsc-site-header.site-header');
  var mainContent = $('.main-content.jsc-main-content');
  var pdpImage = $(
    '.jsc-pdp-page-width .grid--product-images--partial .product-single__sticky'
  );

  header.css('top', announcementBarHeight - 1 + 'px');
  /*if ($(window).width() <= 1024 && $(window).width() >= 768) {
    // ipad only
    var padding = announcementBarHeight + headerHeight;
    mainContent.css('padding-top', padding + 'px');
  } else {  
    mainContent.css('padding-top', announcementBarHeight + 'px');
  }

  if (pdpImage.length > 0) {
    var top = announcementBarHeight + headerHeight + 30;
    pdpImage.css('top', top + 'px');
  }*/
};

adjustFilterText = () => {
  if ($(window).width() < 481) {
    $('.jsc-section-product-filter .jsc-filter-form .mobile-text-2')
      .children()
      .unwrap();
  }
};

openLinkNewTab = () => {
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
};

anchorToCareer = () => {
  var $career = $('.jsc-section-rich-text');
  var top = $career.offset().top - 200;
  window.scrollTo({ top: top, behavior: 'smooth' });
};

addToCartProductComponent = (identifierClass = '.add-to-cart-banner-js') => {
  const addTocartButton = document.querySelectorAll(identifierClass);

  addTocartButton.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Prevent double-clicking
      if (this.classList.contains('is-loading')) {
        return;
      }
      
      // Add loading state
      this.classList.add('is-loading');
      const originalOpacity = this.style.opacity || 1;
      this.style.opacity = '0.6';
      this.style.cursor = 'wait';
      
      // Add loading overlay
      const loadingOverlay = document.createElement('div');
      loadingOverlay.className = 'add-to-cart-banner-js-overlay';
      loadingOverlay.innerHTML = '<div class="add-to-cart-banner-js-spinner"></div>';
      this.appendChild(loadingOverlay);
      
      const productHandle = this.getAttribute('data-product-id');
      
      if (!productHandle) {
        console.error('No product handle specified');
        resetButton(this, originalOpacity);
        return;
      }
      
      // First fetch the product JSON to get the first available variant ID
      fetch('/products/' + productHandle + '.js')
        .then(response => response.json())
        .then(product => {
          // Get first available variant, or first variant if none specified
          let variantId;
          if (product.variants && product.variants.length > 0) {
            // Try to find first available variant
            const availableVariant = product.variants.find(variant => variant.available);
            variantId = availableVariant ? availableVariant.id : product.variants[0].id;
          } else {
            console.error('No variants found for product');
            resetButton(this, originalOpacity);
            return;
          }
          
          const formData = {
            'items': [{
              'id': variantId,
              'quantity': 1
            }]
          };
          
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          });
        })
        .then(response => response.json())
        .then(data => {
          // Optional: Update mini-cart or show confirmation
          window.location.href = '/cart';
        })
        .catch(error => {
          console.error('Error:', error);
          resetButton(this, originalOpacity);
        });
    });
  });

   // Function to reset button state
   function resetButton(button, originalOpacity) {
      button.classList.remove('is-loading');
      button.style.opacity = originalOpacity;
      button.style.cursor = '';
      const overlay = button.querySelector('.add-to-cart-banner-js-loading-overlay');
      if (overlay) {
        button.removeChild(overlay);
      }
    }
}


openKlaviyoForm = (formId) => {
  window._klOnsite = window._klOnsite || []; 
  window._klOnsite.push(['openForm', formId]);
}




/*
 * Synchronizes variant selection across all duplicate wrappers on PDP
 */
function syncVariantSelection(clickedElement) {
  try {
    // Get the product ID from the clicked element
    const productIdMatch = clickedElement.closest('[id*="ProductSelect-"]')?.id?.match(/ProductSelect-(.+?)-option/);
    if (!productIdMatch) {console.warn('Could not identify product ID'); return; }
    const productId = productIdMatch[1];
    // Find the selected value
    const clickedInput = clickedElement.querySelector('input[type="radio"]') || clickedElement.closest('input[type="radio"]');
    if (!clickedInput) return;

    const selectedValue = clickedInput.value;
    const wrappers = document.querySelectorAll(`.variant-wrapper [id*="ProductSelect-${productId}-option"]`);
    if (!wrappers.length) return;

    // Update all matching variants
    wrappers.forEach(wrapper => {
      const inputs = wrapper.querySelectorAll('input[type="radio"]');
      inputs.forEach(input => {
        const isActive = input.value === selectedValue;
        input.classList.toggle('active_variant', isActive);

        // Ensure checked state matches
        if (isActive && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  } catch (error) {
    console.error('Variant sync error:', error);
  }
}

openReamazeWidget = () => {
  var attempts = 0;
  var maxAttempts = 120; // poll up to ~60s (reamaze.js is delay-loaded until first user interaction)
  var timer = setInterval(function () {
    attempts++;
    var widget = document.getElementById('reamaze-widget');
    var trigger =
      widget &&
      (widget.querySelector('[role="button"]') || widget.firstElementChild);
    if (trigger) {
      clearInterval(timer);
      trigger.click();
    } else if (attempts >= maxAttempts) {
      clearInterval(timer);
    }
  }, 500);
};

openOkendoLoyaltyWidget = () => {
  if (window.okeLoyaltyApi) {
    window.okeLoyaltyApi.open();
  } else {
    // okendo-loyalty.onsite.js replays queued calls once it initializes
    window.okeLoyaltyApiPendingCalls = (
      window.okeLoyaltyApiPendingCalls || []
    ).concat([['open', []]]);
  }
};

$(document).ready(function () {
  var params = new URLSearchParams(window.location.search);
  if (params.get('open_widget') === 'reamaze') {
    openReamazeWidget();
  } else if (params.get('open_widget') === 'okendo') {
    openOkendoLoyaltyWidget();
  }
});
